import { render } from "./home-hot.vue?vue&type=template&id=9e52fd40&scoped=true"
import script from "./home-hot.vue?vue&type=script&lang=js"
export * from "./home-hot.vue?vue&type=script&lang=js"

import "./home-hot.vue?vue&type=style&index=0&id=9e52fd40&scoped=true&lang=less"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e52fd40"]])

export default __exports__